import { atom } from "recoil";

export const IdExpiredProductSelectState = atom({
  key: "IdExpiredProductSelectState",
  default: undefined,
});
